import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import SaveIcon from '@mui/icons-material/Save';
/**
 * Save action that confirms success in place: while `saved` is on it turns
 * green with a check instead of showing a separate success banner. The caller
 * owns the timing (flip `saved` back after a short timeout).
 */
export const SaveButton = ({ saved, savedLabel = 'Saved', children = 'Save', disabled, sx, ...buttonProps }) => (_jsx(Button, { variant: 'contained', disabled: disabled || saved, startIcon: saved ? _jsx(CheckIcon, {}) : _jsx(SaveIcon, {}), sx: [
        {
            transition: 'background-color 0.5s ease',
            ...(saved && {
                backgroundColor: 'success.main',
                '&:hover': { backgroundColor: 'success.dark' },
                '&.Mui-disabled': { backgroundColor: 'success.main', color: 'white', opacity: 0.9 }
            })
        },
        ...(Array.isArray(sx) ? sx : [sx])
    ], ...buttonProps, children: saved ? savedLabel : children }));
//# sourceMappingURL=save-button.js.map